import * as React from 'react';
import { pwdValidation } from '../../utils/commonUtilities';
const PasswordStrength = (props) => {
    const { password, initial_pwdErrors } = props;
    const [passwordStrength, setPasswordStrength] = React.useState('');
    React.useEffect(() => {
        checkPasswordStrength(password);
    }, [password]);
    const checkPasswordStrength = (password) => {
        if (pwdValidation(password, initial_pwdErrors, 'passwordStrength')) {
            setPasswordStrength((password.length < 10) ? 'Average' : 'Strong');
        }
        else {
            setPasswordStrength('Weak');
        }
    };
    return (React.createElement(React.Fragment, null, password ? React.createElement("span", null,
        "Password Strength: ",
        React.createElement("span", { className: `strength-text ${passwordStrength.toLowerCase()}` }, passwordStrength)) : ''));
};
export default PasswordStrength;
